import { render, staticRenderFns } from "./product-detail-price.vue?vue&type=template&id=63d500a5&"
import script from "./product-detail-price.vue?vue&type=script&lang=js&"
export * from "./product-detail-price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports